import Styles from './Toolbar.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'

interface ToolbarMenuProps {
  title: string | React.ReactNode
  children: React.ReactNode
  action?: React.ReactNode
  inDesigner?: boolean
  height?: number
}

export const ToolbarMenu = ({ title, children, action, inDesigner, height }: ToolbarMenuProps) => {
  return (
    <div className={cx(Styles.toolbarMenu, { [Styles.inDesigner]: inDesigner })}>
      <div className={Styles.toolbarMenuHeader} style={{ height }}>
        <Text variant="secondary">{title}</Text>
        {action}
      </div>
      {children}
    </div>
  )
}
